<mdb-form-control [formGroup]="form" [class.text-search-with-clear]="showClearButton() && searchControl.value">
  <input
    mdbInput
    type="text"
    [id]="inputId() ?? 'text-search'"
    class="form-control"
    formControlName="{{ searchControlName }}"
    [placeholder]="placeholderKey() | translate"
    [attr.aria-label]="placeholderKey() | translate"
  />
  @if (labelKey()) {
    <label mdbLabel class="form-label" [for]="inputId() ?? 'text-search'">
      {{ labelKey() | translate }}
    </label>
  }
  @if (showClearButton() && searchControl.value) {
    <button
      class="position-absolute top-0 end-0 h-100 border-0 bg-transparent text-muted px-2 d-flex align-items-center"
      type="button"
      (click)="clear()"
      [disabled]="disabled()"
      [title]="'ADMIN.USERS.FILTER_SEARCH_CLEAR' | translate"
      [attr.aria-label]="'ADMIN.USERS.FILTER_SEARCH_CLEAR' | translate"
    >
      &#215;
    </button>
  }
</mdb-form-control>
